import client from '/src/services/client.js';
import unitLabelService from '/src/services/unitLabelService.js';

const invalidateOnSuccess = async (requestPromise) => {
    const result = await requestPromise;
    if (!result[1]) unitLabelService.invalidateCache();
    return result;
};

export default {
    getUnitLabels: () => client.get('api/unit-labels'),
    createUnitLabel: (data) => invalidateOnSuccess(client.post('admin/units', data)),
    updateUnitLabel: (id, data) => invalidateOnSuccess(client.put(`admin/units/${id}`, data)),
    deleteUnitLabel: (id) => invalidateOnSuccess(client.delete(`admin/units/${id}`)),
}
